module.exports = __webpack_public_path__ + "assets/img/SIL_9.4203dbb0.png";